import $ from 'jquery';

let $forms = $('.forms')
const $input = $('input, textarea');
const $upload = $('.ginput_container_fileupload')
const $cards = $('.forms-container .card')
const $form_2 = $('#gform_2')
const $form_1_wrapper = $('#gform_wrapper_1')
const $form_1_form = $('.text-container')
const $form_2_wrapper = $('#gform_wrapper_2')
const $form_1_complete = $('#gform_confirmation_wrapper_1')
const $form_2_complete = $('#gform_confirmation_wrapper_2')
const $form_1_failed = $('#gform_wrapper_1 .gform_validation_errors')
const $form_2_failed = $('#gform_wrapper_2 .gform_validation_errors')
let $title = $('.forms_title')
const $bottom_elements = $('#field_2_5').nextUntil($('.gform_footer')).addBack()
$bottom_elements.wrapAll('<div class="bottom-inputs-container"><div class="bottom-inputs">')
let $bottom_inputs_container = $('.bottom-inputs-container')
let $bottom_inputs = $('.bottom-inputs')

$input.on('focus', function(){
	$(this).closest('.gfield').find('label').addClass('away');
});

$input.on('blur', function(){
	if( !$(this).val() ){
		$(this).closest('.gfield').find('label').removeClass('away');
	}
});

$('input[type="file"]').on('focus', function(){
	$(this).closest('.gfield').find('label').addClass('focus');
});
$('input[type="file"]').on('blur', function(){
	$(this).closest('.gfield').find('label').removeClass('focus');
});

$upload.off().on('click', (e)=> {
	const $this = $(e.currentTarget)
	$this.find('input[type="file"]')[0].click()
})

$('input[type=file]').change(function() {
	let $this = $(this);
	let input = $(this)[0];
	if (input.files && input.files[0]) {
		let reader = new FileReader();
		reader.onload = function(e) {
			let thumbnail = e.target.result;
			let thumbnailContainer = $this.parent().next('.thumbnail-container');
			if (thumbnailContainer.length > 0) {
				thumbnailContainer.find('img').attr('src', thumbnail);
			} else {
				$this.parent().after('<div class="thumbnail-container"><div class="thumbnail-img"><img src="' + thumbnail + '"><div class="remove">X</div></div><div class="success-message">Image Uploaded Successfully</div></div>');
				$('.remove').on('click', (e) => {
					$this = $(e.currentTarget);
					$this.closest('.gfield--type-fileupload').find('.ginput_container_fileupload input').val("");
					$this.parent().parent().remove();
				});
			}
		};
		reader.readAsDataURL(input.files[0]);
	}
});
const check_form_completion = () => {
	if(($form_1_complete).length !== 0 || $form_2_complete.length !== 0) {
		if($form_1_complete.length === 1) {
			$($cards[0]).addClass('dark-card')
			$form_1_form.show()
			$form_2_wrapper.hide()
		} else {
			$($cards[1]).addClass('dark-card')
			$form_2_wrapper.show()
			$form_1_form.hide()
		}
		$title.hide()
	}
	if($form_1_failed.length !== 0 || $form_2_failed.length !== 0) {
		if($form_1_failed.length === 1) {
			console.log('this is true ')
			$($cards[0]).addClass('dark-card')
			$form_1_form.show()
			$form_2_wrapper.hide()
			$title.css('opacity', '1')
		} else {
			$($cards[1]).addClass('dark-card')
			$form_1_form.hide()
			$form_2_wrapper.show()
			$bottom_inputs.css('opacity', '1')
			$bottom_inputs_container.show()
			$title.css('opacity', '1')
		}
	}
}

$(window).on('load', () => {
	check_form_completion()
})

$cards.on('click', (e) => {
	const $this = $(e.currentTarget)
	if($this.hasClass('phone')) {
		if($(window).innerWidth() < 900) {
			$forms.detach()
			$('.card.phone').after($forms)
		}
		if($form_1_complete.length === 1) {
			$bottom_inputs_container.hide()
			$form_1_complete.show()
			$form_2_wrapper.hide()
			$title.hide()
		} else if( $form_2_complete.length === 1) {
			$title.hide()
			$title.css('opacity', '1')
			$form_2_complete.hide()
			$form_1_form.slideDown(700).animate({'opacity': 1}, 700)
		} else {
			$form_1_form.slideDown(700)
			$title.hide()
			$form_1_form.animate({'opacity': 1}, 700)
			$form_2_wrapper.hide()
			$bottom_inputs_container.slideUp(700)
			$bottom_inputs.animate({'opacity': 0}, 700)
		}
	} else {
		if($(window).innerWidth() < 900) {
			$forms.detach()
			$('.card.online').after($forms)
		}
		$form_2.trigger('reset')
		$('.thumbnail-container').remove()
		$form_1_form.hide()
		$title.show()
		$form_1_complete.hide()
		$form_2_wrapper.show()
		$bottom_inputs_container.slideDown(700)
		$bottom_inputs.animate({'opacity': 1}, 700)
		if($form_2_complete.length === 1) {
			$form_2_complete.show()
			$title.hide()
		} else {
			$title.show()
			$title.css('opacity', '1')
		}
	}
	$cards.removeClass('dark-card')
	$this.addClass('dark-card')
})